import React from "react";
import numbro from "numbro";

const PoMobileItem = ({ item, index }) => {
    return (
        <div key={index} className="mt-3 px-3">
            {/* SKU Title Row */}
            <div className="d-flex align-items-center">
                <span
                    className="me-2"
                    style={{
                        fontSize: "12px",
                        fontFamily: "Inter, sans-serif",
                        color: "#616E7C",
                        fontWeight: 400,
                        minWidth: "12px",
                        textAlign: "right",
                        lineHeight: "1.2",
                    }}
                >
                    {index + 1}
                </span>
                <span
                    style={{
                        fontSize: "14.5px",
                        fontFamily: "Inter, sans-serif",
                        color: "#000",
                        fontWeight: 400,
                        lineHeight: "1.2",
                    }}
                >
                    {item.sku_name}
                </span>
            </div>

            {/* Data Row: Price | Quantity | Payable */}
            <div className="row text-center mt-3">
                {/* Price */}
                <div className="col-4 d-flex justify-content-start">
                    <div className="d-flex align-items-start">
                        <span
                            className="me-2"
                            style={{
                                minWidth: "12px",
                                visibility: "hidden",
                            }}
                        >
                            {index + 1}
                        </span>
                        <div className="d-flex flex-column" style={{ minWidth: "max-content" }}>
                            <div
                                style={{
                                    fontSize: "13px",
                                    fontFamily: "Inter, sans-serif",
                                    color: "#000",
                                    fontWeight: 400,
                                    lineHeight: 1.2,
                                    textAlign: "right",
                                }}
                            >
                                PKR{" "}
                                {numbro((item.procurement_unit_price_paisas || 0) / 100.0).format({
                                    thousandSeparated: true,
                                    mantissa: 2,
                                })}
                            </div>
                            <div
                                style={{
                                    fontSize: "11px",
                                    color: "#616E7C",
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: 400,
                                    lineHeight: 1.2,
                                    textAlign: "right",
                                }}
                            >
                                per {item.procurement_label}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quantity */}
                <div
                    className="col-4 d-flex justify-content-center position-relative"
                    style={{
                        paddingLeft: "8px",
                        paddingRight: "8px"
                    }}
                >
                    {/* Left vertical divider */}
                    <div
                        style={{
                            position: "absolute",
                            left: "0",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "1.25px",
                            height: "21px",
                            backgroundColor: "#E4E7EB"
                        }}
                    />
                    {/* Right vertical divider */}
                    <div
                        style={{
                            position: "absolute",
                            right: "0",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "1.25px",
                            height: "21px",
                            backgroundColor: "#E4E7EB"
                        }}
                    />
                    <div className="d-flex align-items-start" style={{ width: "80%" }}>
                        <div className="text-end me-1" style={{ width: "40%" }}>
                            <div style={{ fontSize: "13px", fontFamily: "Inter, sans-serif", fontWeight: 400, lineHeight: "1.2" }}>
                                {numbro(item.procurement_units).format({ thousandSeparated: true })}
                            </div>
                            <div
                                className="text-muted"
                                style={{ fontSize: "11px", fontFamily: "Inter, sans-serif", textAlign: "right", fontWeight: 400, lineHeight: "1.2" }}
                            >
                                {item.procurement_label}
                            </div>
                        </div>
                        <div
                            className="fw-bold mx-1 text-end"
                            style={{
                                fontSize: "13px",
                                color: "#616E7C",
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 400,
                                lineHeight: "1.2",
                                width: "20%",
                                marginInline: "100px"
                            }}
                        >
                            =
                        </div>
                        <div className="text-end" style={{ width: "40%" }}>
                            <div style={{ fontSize: "13px", fontFamily: "Inter, sans-serif", fontWeight: 400, lineHeight: "1.2" }}>
                                {numbro(item.selling_units).format({ thousandSeparated: true })}
                            </div>
                            <div
                                className="text-muted"
                                style={{ fontSize: "11px", fontFamily: "Inter, sans-serif", textAlign: "right", fontWeight: 400, color: "#616E7C", lineHeight: "1.2" }}
                            >
                                {item.selling_label}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Payable */}
                <div className="col-4 text-end">
                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "#000",
                            fontFamily: "Inter, sans-serif",
                            lineHeight: "1.1",
                        }}
                    >
                        PKR{" "}
                        {numbro((item.payable_paisas || 0) / 100.0).format({
                            thousandSeparated: true,
                            mantissa: 2,
                        })}
                    </div>
                    <div
                        className="text-muted"
                        style={{
                            fontSize: "11px",
                            textAlign: "right",
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 400,
                            lineHeight: "1.2",
                        }}
                    >
                        Payable
                    </div>
                </div>
            </div>
            {/* Divider after each SKU */}
            <hr
                className="mt-3 mb-0 mx-0"
                style={{
                    height: '1px',
                    backgroundColor: '#616E7C',
                    border: 'none',
                }}
            />
        </div>
    );
};

export default PoMobileItem; 